import { Layout, Row, Col } from 'antd';
// styles

// components
import LanguageSwitcher from 'components/LanguageSwitcher';

const { Content } = Layout;

const AuthenticationLayout = ({ children }) => {
    return (
        <Layout>
            <Content>
                <Row className="authentication-page">
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Row justify="center" align="middle">
                            {children}
                        </Row>
                    </Col>
                    <Col xs={0} sm={0} md={12} lg={12} xl={12} className="authentication-media">
                        <Row justify="end">
                            <LanguageSwitcher />
                        </Row>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
};

export default AuthenticationLayout;
